import {
    AUTH_ERROR_CODE_EMAIL_ALREADY_IN_USE,
    AUTH_ERROR_CODE_INVALID_EMAIL,
    AUTH_ERROR_CODE_USER_NOT_FOUND,
    AUTH_ERROR_CODE_WRONG_PASSWORD,
    AUTH_ERROR_MSG_DEFAULT,
    AUTH_ERROR_MSG_EMAIL_ALREADY_IN_USE,
    AUTH_ERROR_MSG_INVALID_EMAIL,
    AUTH_ERROR_MSG_USER_NOT_FOUND,
    AUTH_ERROR_MSG_WRONG_PASSWORD,
} from './constants';
import _get from 'lodash/get';

export const getAfitdAuthError = authError => {
    const code = _get(authError, 'code');
    const message = _get(authError, 'message');
    switch (code) {
        case AUTH_ERROR_CODE_WRONG_PASSWORD:
            return { ...authError, displayMessage: AUTH_ERROR_MSG_WRONG_PASSWORD };
        case AUTH_ERROR_CODE_USER_NOT_FOUND:
            return { ...authError, displayMessage: AUTH_ERROR_MSG_USER_NOT_FOUND };
        case AUTH_ERROR_CODE_EMAIL_ALREADY_IN_USE:
            return { ...authError, displayMessage: AUTH_ERROR_MSG_EMAIL_ALREADY_IN_USE };
        case AUTH_ERROR_CODE_INVALID_EMAIL:
            return { ...authError, displayMessage: AUTH_ERROR_MSG_INVALID_EMAIL };
        default: {
            console.error(`${code}: ${message}`);
            return { ...authError, displayMessage: AUTH_ERROR_MSG_DEFAULT };
        }
    }
};

export const checkPasswordStrength = str => {
    var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return re.test(str);
};
